/* Written by Codex Sol by Ren */
(() => {
  if (window.canonPreorderNotice) {
    window.canonPreorderNotice.refresh();
    return;
  }

  let timer;
  let revision = 0;
  let datesByVariant = new Map();
  let latestDate = null;
  const root = window.Shopify?.routes?.root || '/';
  const messages = JSON.parse(document.getElementById('canon-preorder-messages').textContent);
  const animationKey = 'canon-preorder-notice-animated';
  let animated = false;
  try {
    animated = sessionStorage.getItem(animationKey) === '1';
  } catch {}

  const visibleNotices = new Set();
  function revealNotice(target) {
    if (document.visibilityState === 'hidden' || !target.isConnected) return;
    visibilityObserver.unobserve(target);
    visibleNotices.delete(target);
    target.classList.remove('canon-preorder-checkout-notice--pending');
    if (animated) return;
    animated = true;
    try {
      sessionStorage.setItem(animationKey, '1');
    } catch {}
    target.classList.add('canon-preorder-checkout-notice--enter');
    const finishAnimation = event => {
      if (event.animationName !== 'canon-preorder-underline') return;
      target.classList.remove('canon-preorder-checkout-notice--enter');
      target.removeEventListener('animationend', finishAnimation);
    };
    target.addEventListener('animationend', finishAnimation);
  }
  const visibilityObserver = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
      if (!isIntersecting || intersectionRatio < 0.8 || !target.isConnected) {
        visibleNotices.delete(target);
        return;
      }
      visibleNotices.add(target);
      revealNotice(target);
    });
  }, { threshold: 0.8 });
  document.addEventListener('visibilitychange', () => visibleNotices.forEach(revealNotice));

  function createHelp() {
    const help = document.createElement('div');
    help.id = 'canon-preorder-help';
    help.className = 'canon-preorder-help unicorn_body_font';
    const button = document.createElement('button');
    button.id = 'canon-preorder-checkout-notice';
    button.type = 'button';
    button.className = 'canon-preorder-checkout-notice canon-preorder-help-button unicorn_body_font';
    button.setAttribute('aria-live', 'polite');
    button.setAttribute('aria-controls', 'canon-preorder-help-panel');
    button.setAttribute('aria-expanded', 'false');
    const label = document.createElement('span');
    label.className = 'canon-preorder-date-label';
    const icon = document.createElement('span');
    icon.className = 'canon-preorder-info-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = 'i';
    button.append(label, icon);
    const panel = document.createElement('div');
    panel.id = 'canon-preorder-help-panel';
    panel.className = 'canon-preorder-help-panel';
    panel.setAttribute('role', 'tooltip');
    panel.hidden = true;
    panel.textContent = messages.split_help;
    button.setAttribute('aria-describedby', panel.id);
    let pinned = false;
    const show = open => {
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
    };
    help.addEventListener('mouseenter', () => show(true));
    help.addEventListener('mouseleave', () => {
      if (!pinned && !help.contains(document.activeElement)) show(false);
    });
    button.addEventListener('focus', () => show(true));
    help.addEventListener('focusout', event => {
      if (!pinned && !help.contains(event.relatedTarget)) show(false);
    });
    button.addEventListener('click', () => {
      pinned = !pinned;
      show(pinned);
    });
    help.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        pinned = false;
        show(false);
        event.preventDefault();
      }
    });
    const dismiss = event => {
      if (!help.contains(event.target)) {
        pinned = false;
        show(false);
      }
    };
    help.canonDismiss = dismiss;
    help.append(button, panel);
    return help;
  }

  function parseDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(value + 'T00:00:00Z');
    return Number.isFinite(date.getTime()) &&
      date.toISOString().slice(0, 10) === value ? date : null;
  }

  function formatDate(date, month) {
    return date.toLocaleDateString(messages.locale, {
      year: 'numeric', month, day: 'numeric', timeZone: 'UTC'
    });
  }

  function render() {
    document.querySelectorAll('.unicorn_cart_item').forEach(row => {
      const title = row.querySelector('.unicorn_cart_cell_title');
      const link = title?.closest('a') || row.querySelector('.unicorn_cart_cell_media a');
      const variant = link ? new URL(link.href, location.origin).searchParams.get('variant') : null;
      const date = datesByVariant.get(variant);
      let pill = row.querySelector('.canon-preorder-pill');
      if (!date || !title) {
        pill?.remove();
        return;
      }
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'canon-preorder-pill unicorn_body_font';
        (title.closest('a') || title).insertAdjacentElement('afterend', pill);
      }
      const label = messages.ships.replace('__DATE__', formatDate(date, 'short'));
      if (pill.textContent !== label) pill.textContent = label;
      pill.title = messages.ships.replace('__DATE__', formatDate(date, 'long'));
    });

    const container = document.getElementById('preorder-notices');
    if (container?.childNodes.length) container.replaceChildren();
    const checkout = document.querySelector('#unicorn_checkout_submit, #unicorn_checkout_submit_alternative');
    let notice = document.getElementById('canon-preorder-checkout-notice');
    let help = document.getElementById('canon-preorder-help');
    if (!latestDate || !checkout) {
      help?.remove();
      if (notice) {
        visibilityObserver.unobserve(notice);
        visibleNotices.delete(notice);
        notice.remove();
      }
      return;
    }
    if (!help) {
      help = createHelp();
      notice = help.querySelector('#canon-preorder-checkout-notice');
      for (let ancestor = checkout.parentElement; ancestor; ancestor = ancestor.parentElement) {
        const background = getComputedStyle(ancestor).backgroundColor;
        const alphaMatch = background.match(/^rgba\(.+,\s*([\d.]+)\s*\)$/) ||
          background.match(/\/\s*([\d.]+)(%)?\s*\)$/);
        const alpha = alphaMatch ? Number(alphaMatch[1]) / (alphaMatch[2] ? 100 : 1) : 1;
        if (background && background !== 'transparent' && alpha === 1) {
          help.style.backgroundColor = background;
          break;
        }
      }
      if (!animated) {
        notice.classList.add('canon-preorder-checkout-notice--pending');
        visibilityObserver.observe(notice);
      }
    }
    const label = messages.order_notice.replace('__DATE__', formatDate(latestDate, 'long'));
    const dateLabel = notice.querySelector('.canon-preorder-date-label');
    if (dateLabel.textContent !== label) dateLabel.textContent = label;
    notice.setAttribute('aria-label', `${label}. ${messages.split_label}`);
    if (checkout.previousElementSibling !== help) checkout.before(help);
  }

  async function update(version) {
    try {
      const response = await fetch(root + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Could not load cart');
      const cart = await response.json();
      const pages = new Map();
      const dates = await Promise.all(cart.items.map(async item => {
        if (!item.requires_shipping) return null;
        const url = new URL(item.url, location.origin);
        if (url.origin !== location.origin) return null;
        url.search = '';
        url.hash = '';
        if (!pages.has(url.href)) {
          pages.set(url.href, fetch(url.href, { cache: 'no-store' })
            .then(res => {
              if (!res.ok) throw new Error('Could not load product');
              return res.text();
            })
            .then(html => new DOMParser().parseFromString(html, 'text/html')));
        }
        const page = await pages.get(url.href);
        const field = Array.from(page.querySelectorAll('[data-ships_on]'))
          .find(element => element.id === String(item.variant_id));
        return parseDate(field?.getAttribute('data-ships_on'));
      }));
      if (version !== revision) return;
      const now = new Date();
      const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
      datesByVariant = new Map();
      cart.items.forEach((item, index) => {
        const date = dates[index];
        if (date && date.getTime() >= today) datesByVariant.set(String(item.variant_id), date);
      });
      latestDate = datesByVariant.size ?
        new Date(Math.max(...Array.from(datesByVariant.values(), date => date.getTime()))) : null;
      render();
    } catch (error) {
      if (version === revision) {
        datesByVariant.clear();
        latestDate = null;
        render();
        console.error('Preorder notice:', error);
      }
    }
  }

  function refresh() {
    const version = ++revision;
    clearTimeout(timer);
    datesByVariant.clear();
    latestDate = null;
    render();
    timer = setTimeout(() => update(version), 150);
  }

  document.addEventListener('pointerdown', event => {
    document.getElementById('canon-preorder-help')?.canonDismiss?.(event);
  });
  window.canonPreorderNotice = { refresh };
  ['unicornCartReady', 'unicornCartOpened', 'unicornCartDataChanged',
    'unicornItemAddedToCart'].forEach(event => document.addEventListener(event, refresh));
  new MutationObserver(records => {
    const relevant = records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.id === 'preorder-notices' || node.id === 'unicorn_checkout_submit' ||
        node.id === 'unicorn_checkout_submit_alternative' ||
        node.matches('.unicorn_cart_items, .unicorn_cart_item, .unicorn_cart_cell_title') ||
        node.querySelector('#preorder-notices, #unicorn_checkout_submit, #unicorn_checkout_submit_alternative, .unicorn_cart_item, .unicorn_cart_cell_title'))
    ));
    if (relevant) render();
  }).observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();
